/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 FacebookLogin = {
    processing: false,
    connect: function() {
        if (FacebookLogin.processing === false) {
            FacebookLogin.processing = true;

            FB.getLoginStatus(function(response) {
                if (response.status === 'connected') {
                    FacebookLogin.sendData(response.authResponse.accessToken);
                } else {
                    FB.login(function(response) {
                        if (response.status === 'connected') {
                            FacebookLogin.sendData(response.authResponse.accessToken);
                        } else {
                            Alertbox({
                                title: "Erro ao conectar",
                                content: 'Você precisa autorizar nosso aplicativo do Facebook para se conectar',
                                type: 'error'
                            });

                            FacebookLogin.processing = false;
                        }
                    }, {scope: 'public_profile,email'});
                }
            });
        }
    },
    sendData: function(accessToken) {
        FB.api('/me', {fields: 'id,email,name,picture.type(large)'}, function(response) {
            response.accessToken = accessToken;

            $.ajax({
                url: '/a/user/facebookLogin',
                type: 'POST',
                dataType: 'json',
                data: response
            }).done(function(data) {
                FacebookLogin.processing = false;

                if (data.status == 'success') {
                    location.replace(data.location);
                } else if (data.status == 'error') {
                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i] + "<br>";
                    }

                    Alertbox({
                        title: "Erro ao conectar",
                        content: message,
                        type: 'error'
                    });
                }
            });
        });
    },
    init: function() {
        $(".connect-with-facebook").on('click', FacebookLogin.connect);
    }
};

$(document).ready(function() {
    FacebookLogin.init();
});
